import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { LodgingSelectionEnum, PlaceIdEnum } from "@b2bportal/lodging-api";

import { fetchLocations, useHotelLocationAutocomplete } from "@tenant/hotels";
import {
  Icon,
  LocationAutocomplete,
  type LocationAutocompleteProps,
} from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HotelLocationAutocomplete.module.scss";
import type { HotelLocationSuggestion } from "./types";

export interface HotelLocationAutocompleteProps
  extends Omit<
    LocationAutocompleteProps<HotelLocationSuggestion>,
    "fetch" | "groupBy" | "getOptionLabel" | "sortOptions"
  > {
  value?: HotelLocationSuggestion;
  defaultValue?: HotelLocationSuggestion;
  className?: string;
}

export const HotelLocationAutocomplete = (
  props: HotelLocationAutocompleteProps
) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelLocationAutocomplete;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers } = useHotelLocationAutocomplete(props);

  return (
    <div className={clsx(block, props.className)}>
      <LocationAutocomplete<HotelLocationSuggestion>
        id={context.id}
        value={context.value}
        defaultValue={context.defaultValue}
        label={context.label}
        onChange={handlers.onChange}
        fetch={fetchLocations}
        getOptionLabel={getOptionLabel}
        icon={<Icon iconName={IconNameEnum.mapPin} />}
        className={context.className}
        paperClassName={cn("location-paper")}
        popperClassName={cn("location-popper")}
        onOpen={handlers.onOpen}
        placeholder={context.placeholder}
        getOptionIcon={getOptionIcon}
        useDialogOnMobile={context.useDialogOnMobile ?? true}
        mobileDialogTitle={context.mobileDialogTitle}
        error={props.error}
        onFocus={handlers.onFocus}
      />
    </div>
  );
};

const getOptionLabel = (value?: HotelLocationSuggestion) => {
  if (
    value?.id.Id === PlaceIdEnum.Lodgings &&
    value.id.lodgingSelection.LodgingSelection === LodgingSelectionEnum.Place
  ) {
    return value.id.lodgingSelection.searchTerm;
  }
  return "";
};

const getOptionIcon = (value?: HotelLocationSuggestion) => {
  return <Icon iconName={IconNameEnum.mapPin} />;
};
